(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wi-rotating-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wi-hero-carousel')) {
    class WIHeroCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-wi-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-wi-dot]'));
        this.track = this.querySelector('[data-wi-track]');
        this.toggleButton = this.querySelector('[data-wi-toggle]');
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.speed = Number(this.dataset.speed) || 5000;
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.userPaused = false;
        this.focusPaused = false;
        this.visibilityHandler = this.handleVisibilityChange.bind(this);

        this.querySelector('[data-wi-previous]')?.addEventListener('click', () => this.show(this.currentIndex - 1, true));
        this.querySelector('[data-wi-next]')?.addEventListener('click', () => this.show(this.currentIndex + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.index), true)));
        this.toggleButton?.addEventListener('click', () => this.toggleAutoplay());
        this.addEventListener('focusin', () => this.pauseForFocus());
        this.addEventListener('focusout', (event) => this.resumeAfterFocus(event));
        document.addEventListener('visibilitychange', this.visibilityHandler);

        this.show(this.currentIndex, false);
        this.play();
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.visibilityHandler);
      }

      show(index, resetTimer) {
        if (this.slides.length === 0) return;
        this.currentIndex = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (resetTimer && this.autoplayEnabled && !this.userPaused && !this.focusPaused) this.play();
      }

      play() {
        window.clearInterval(this.timer);
        if (!this.autoplayEnabled || this.userPaused || this.focusPaused || this.slides.length < 2 || document.hidden) return;
        this.track?.setAttribute('aria-live', 'off');
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1, false), this.speed);
      }

      pause() {
        window.clearInterval(this.timer);
        this.track?.setAttribute('aria-live', 'polite');
      }

      toggleAutoplay() {
        this.userPaused = !this.userPaused;
        this.toggleButton?.classList.toggle('is-paused', this.userPaused);
        this.toggleButton?.setAttribute(
          'aria-label',
          this.userPaused ? window.accessibilityStrings.playSlideshow : window.accessibilityStrings.pauseSlideshow
        );
        if (this.userPaused) {
          this.pause();
        } else {
          this.play();
        }
      }

      pauseForFocus() {
        if (this.userPaused) return;
        this.focusPaused = true;
        this.pause();
      }

      resumeAfterFocus(event) {
        if (this.contains(event.relatedTarget)) return;
        this.focusPaused = false;
        this.play();
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.pause();
        } else {
          this.play();
        }
      }
    }

    customElements.define('wi-hero-carousel', WIHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
